import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Handshake, Loader2, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_a72ee028-442b-44ea-ad3d-be1abd62a5cf/artifacts/zdjtc3rc_Logo_Falo_com_o_dono-removebg-preview.png";

const PartnerAccess = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleAccess = async () => {
    if (!email.trim()) { setError('Digite seu email'); return; }
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${API}/partners/access-by-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Erro');
      window.location.href = `/parceiro/painel/${data.panel_token}`;
    } catch (e) {
      setError(e.message || 'Email não encontrado');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A2647] flex items-center justify-center p-6" data-testid="partner-access-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="FaloComODono" className="h-14 mx-auto mb-6 object-contain" />
          <div className="w-14 h-14 rounded-2xl bg-[#C5A059]/15 flex items-center justify-center mx-auto mb-4">
            <Handshake className="w-7 h-7 text-[#C5A059]" />
          </div>
          <h1 className="text-2xl font-bold text-white mb-2">Area do Parceiro</h1>
          <p className="text-slate-400 text-sm">Digite o email cadastrado como parceiro para acessar seu painel</p>
        </div>

        <div className="space-y-4">
          <div>
            <Label className="text-xs font-medium text-slate-400">Seu Email</Label>
            <Input
              type="email"
              value={email}
              onChange={e => { setEmail(e.target.value); setError(''); }}
              onKeyDown={e => e.key === 'Enter' && handleAccess()}
              placeholder="seu@email.com"
              className="mt-1 h-12 bg-white/5 border-white/10 text-white placeholder:text-slate-500 text-sm"
              data-testid="partner-access-email"
            />
          </div>

          {error && (
            <p className="text-red-400 text-xs" data-testid="partner-access-error">{error}</p>
          )}

          <Button
            onClick={handleAccess}
            disabled={loading}
            className="w-full h-12 bg-[#C5A059] hover:bg-[#b8933f] text-[#0A2647] font-bold text-sm"
            data-testid="partner-access-submit"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Acessar Meu Painel'}
          </Button>

          <Link to="/" className="flex items-center justify-center gap-2 text-sm text-slate-400 hover:text-white transition-colors mt-4">
            <ArrowLeft className="w-4 h-4" />Voltar ao site
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PartnerAccess;
